import { render, staticRenderFns } from "./BackLink.vue?vue&type=template&id=cbcb6212&scoped=true&"
import script from "./BackLink.vue?vue&type=script&lang=js&"
export * from "./BackLink.vue?vue&type=script&lang=js&"
import style0 from "./BackLink.vue?vue&type=style&index=0&id=cbcb6212&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcb6212",
  null
  
)

export default component.exports